// The 20 colours a text or icon tag can take, in the order the tag manager offers them. A
// tag's id is its colour's position in this list plus one (0 would be falsy in the editors'
// checks), so each colour belongs to at most one tag per editor. Out of CustomizerScreen
// (backfill PR 30), which passes the list to both editors; frozen, as it lives for the whole
// process and the editors only read it.
export const predefinedTagColors = Object.freeze([
  '#000000', // Black
  '#4B4B4B', // Dark Grey
  '#A9A9A9', // Grey
  '#D3D3D3', // Light Grey
  '#8B4513', // Saddle Brown
  '#a90000', // Dark Red
  '#ff0000', // Red
  '#ffbe98', // Pink
  '#FF7F00', // Orange
  '#ffff00', // Yellow
  '#006400', // Dark Green
  '#00b200', // Green
  '#A2E4B8', // mint green
  '#00ff00', // light green
  '#00008B', // Dark Blue
  '#007FFF', // Azure
  '#89CFF0', // Baby Blue
  '#00FFFF', // Cyan
  '#7F00FF', // Violet
  '#FF00FF', // Magenta
]);
